import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessagingService } from '@services/messaging.service';
import { PrimeNG } from 'primeng/config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  title = 'tucuate-web';

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private titleService: Title,
    private primeNG: PrimeNG,
    private translateService: TranslateService,
    private messagingService: MessagingService,
  ) {
    this.initTranslateService();
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.messagingService.listen();
    }
  }

  private initTranslateService() {
    const browserLang = this.translateService.getBrowserLang();

    this.translateService.addLangs(['es']);
    this.translateService.setDefaultLang('es');
    this.translateService.use(browserLang?.match(/es/) ? browserLang : 'es');

    this.primeNG.ripple.set(true);
    this.translateService.stream('primeng').subscribe((data) => {
      this.primeNG.setTranslation(data);
    });
  }
}
